import {ModelLoader} from "./loader";
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader.js';

export class FBXModelLoader extends ModelLoader {

    constructor() {
        super();
        this.loader = new FBXLoader();
    }
}